import React, { useState } from 'react';
import { Switch } from 'antd';

const CommonSwitch = ({size="small", checked=false, onClick}) => {
    const [myChecked, setMyChecked] = useState(checked);

    const onMyClick = () => {
        onClick()
        setMyChecked(!myChecked)
    }
    
    return (
        <Switch
            size={size}
            checked={myChecked}
            onClick={onMyClick}
        />
    );
}

export default CommonSwitch;